import type { Volume } from '@/entities/volume';
import request from '@/shared/api/request';

export const createVolume = (data: {
  name: string;
  size_gigabytes: number;
  stacklet_id: number;
}): Promise<{ volume: Volume }> =>
  request({
    url: '/volumes/',
    method: 'POST',
    data,
  });
